import React, {useContext} from 'react';
import {jsonToCSV} from 'react-papaparse';

import debounce from 'lodash.debounce';
import moment from 'moment/moment';
import {DownloadButton} from 'src/components/form-buttons';
import {useEventTracking} from 'src/hooks/useEventTracking';
import {mapDateFormat} from 'src/utils/mapDateFormat';

import {LocaleContext} from '@pb/kit-context-locale';

type Props = {
    toolName: string,
    fileName: string,
    startTime: string,
    headers: Record<string, string>,
    body: Record<string, string>[],
    meta?: string,
};

export const BulkActionDownload = ({toolName, startTime, fileName, headers, body, meta}: Props) => {
    const {bulkDownload} = useEventTracking();
    const {locale} = useContext(LocaleContext);

    const formatActionStatus = (status: string): string => {
        return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
    };

    const saveFile = debounce(() => {
        bulkDownload({toolName});

        const dataWithHeaders = [headers, ...body.map(item => ({
            ...item,
            actionStatus: item.actionStatus === 'FAILED'
                ? item.errors
                : formatActionStatus(item.actionStatus),
        }))];
        const csv = jsonToCSV(dataWithHeaders, {
            delimiter: ',',
            header: false,
            newline: '\r\n',
            quotes: true,
            skipEmptyLines: true,
        });

        const blob = new Blob([meta ? meta + '\n' + csv : csv], {type: 'text/csv'});
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;

        link.download = `${fileName}_${moment(startTime).format(
            mapDateFormat(locale.dateFormat, 'FILE_NAME', 'DATE_TIME'),
        )}.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    }, 500);

    return (
        <DownloadButton disabled={false} handler={saveFile}/>
    );
};
